import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Table, Card, Loader, Icon, Dropdown, Popup} from 'semantic-ui-react';
import {headerCellTitlesOfData, headerCellTitlesOfControl} from '../../static/commonStructures';
import {pageSizes} from '../../../../common/constants/lists';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import TablePaginator from '../../../../common/components/tablePaginator';

const fieldsToDisplay = headerCellTitlesOfData.concat(headerCellTitlesOfControl);

class PriceFactorsTable extends Component {
  constructor(props) {
    super(props);
    this.renderDataInCells = this.renderDataInCells.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
  }

  componentDidMount() {
    this.props.clearPriceFactorsList();
  }

  componentDidUpdate(prevProps) {
    const {pageNumber, pageSize, priceFactorsList} = this.props;

    if (priceFactorsList.length === 0) {
      return;
    }

    if (pageNumber !== prevProps.pageNumber || pageSize !== prevProps.pageSize) {
      this.props.onUpdate();
    }
  }

  handlePageSizeChange(event, data) {
    this.props.changePriceFactorsListPage(0);
    this.props.changePriceFactorsListPageSize(data.value);
  }

  handlePageClick(value) {
    this.props.changePriceFactorsListPage(value);
  }

  renderTableHeader() {
    return (
      <Table.Header>
        <Table.Row>
          {this.renderTableHeaderCells()}
        </Table.Row>
      </Table.Header>
    );
  }

  renderTableHeaderCells() {
    return (
      fieldsToDisplay.map((element) => {
        return (
          <Table.HeaderCell key={`header${element.name}`} textAlign='center'>
            {element.name}
          </Table.HeaderCell>
        );
      })
    );
  }

  renderTableBody() {
    const {priceFactorsListLoading} = this.props;
    return (
      <Table.Body>
        {priceFactorsListLoading ? this.renderLoader() : this.renderPriceFactors()}
      </Table.Body>
    );
  }

  renderLoader() {
    return (
      <Table.Row>
        <Table.Cell colSpan='100%' textAlign='center'>
          <Loader active inline='centered' />
        </Table.Cell>
      </Table.Row>
    );
  }

  renderPriceFactors() {
    const {priceFactorsList} = this.props;
    if (!priceFactorsList) {
      return null;
    }

    return priceFactorsList.map((row, rowIndex) => {
      return (
        <Table.Row key={`row${rowIndex}`}>
          {this.renderDataInCells(row, rowIndex)}
          {this.renderActionsInCells(row)}
        </Table.Row>
      );
    });
  }

  renderDataInCells(element, rowIndex) {
    return (
      headerCellTitlesOfData.map((title, columnIndex) => {
        return (
          <Table.Cell
            textAlign='center'
            key={`element${rowIndex}${columnIndex}`}
          >{element[title.serializedName] || 'N/A'}</Table.Cell>
        );
      })
    );
  }

  renderActionsInCells(row) {
    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link
              to={paths.PriceFactorsEdit}
              state={{
                'action': 'edit',
                'recordId': row.productCode,
              }}
            >
              <Icon
                name='write'
                color='blue'
                className='action-icon'
              />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />
        <Popup
          trigger={
            <Link
              to={paths.PriceFactorsClone}
              state={{
                'action': 'clone',
                'recordId': row.productCode,
              }}
            >
              <Icon
                name='copy'
                color='blue'
                className='action-icon'
              />
            </Link>
          }
          content='Clonar'
          position='top center'
          inverted
        />
      </Table.Cell>
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems, priceFactorsList} = this.props;

    if (totalItems <= pageSize || !priceFactorsList.length) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className = 'page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.handlePageSizeChange}
                />
              </span>
              <TablePaginator
                itemsCount = {totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.handlePageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderTable() {
    return (
      <Card fluid raised>
        <div className='horizontal-scroll'>
          <Table>
            {this.renderTableHeader()}
            {this.renderTableBody()}
          </Table>
        </div>
        <Table className='pagination-table'>
          {this.renderPagination()}
        </Table>
      </Card>
    );
  }

  render() {
    return (
      this.renderTable()
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'priceFactorsList': state.priceFactorsList.list,
    'priceFactorsListLoading': state.priceFactorsList.loading,
    'pageNumber': state.priceFactorsList.offset,
    'pageSize': state.priceFactorsList.limit,
    'totalItems': state.priceFactorsList.count,
  };
};

const {
  changePriceFactorsListPage,
  changePriceFactorsListPageSize,
  clearPriceFactorsList,
} = Actions;

export default connect(mapStateToProps, {
  changePriceFactorsListPage,
  changePriceFactorsListPageSize,
  clearPriceFactorsList,
})(PriceFactorsTable);
